import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlice"><Path d="M2.5 6.5L5.5 3.5L21.5 19.4617C15 21.2 11.3333 21.36 5 15L8 12L2.5 6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlice;
